import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import auth0Client from '../Auth';

class Questions extends Component {
  constructor(props) {
    super(props);

    this.state = {
      questions: null
    };
  }

  async componentDidMount() {
    const questions = (await axios.get(
      'https://4z8a9fq0e7.execute-api.us-east-1.amazonaws.com/dev/questions/',
      {
        headers: { Authorization: `Bearer ${auth0Client.getIdToken()}` }
      }
    )).data;

    this.setState({
      questions
    });
  }

  render() {
    return (
      <div className="container">
        {!auth0Client.isAuthenticated() && (
          <div className="row">
            <div className="col-md-12">
              <div className="alert alert-danger" role="alert">
                You must log in in order to ask questions. You can log in with
                your Google account.
              </div>
            </div>
          </div>
        )}
        {auth0Client.isAuthenticated() && (
          <div className="row new-question-btn">
            <div className="col-sm-12 col-md-4 col-lg-3">
              <Link className="btn btn-primary" to="/new-question">
                Ask A Question!
              </Link>
            </div>
          </div>
        )}
        {this.state.questions === null && (
          <div className="d-flex justify-content-center">
            <div className="loader" />
          </div>
        )}

        <div className="row">
          {this.state.questions &&
            this.state.questions.map(question => (
              <div
                key={question.createdAt}
                className="col-sm-12 col-md-4 col-lg-3"
              >
                <Link to={`/question/${question.id}`}>
                  <div className="card text-white bg-success mb-3">
                    <div className="card-header">
                      {question.title}
                      {/* Answers: {question.answers} */}
                    </div>
                    {/* <div className="card-body"> */}
                    {/* <h4 className="card-title">{question.title}</h4> */}
                    {/* <p className="card-text">{question.description}</p> */}
                    {/* <p className="card-text">{question.id}</p> */}
                    {/* </div> */}
                  </div>
                </Link>
              </div>
            ))}
        </div>
      </div>
    );
  }
}

export default Questions;
